import type { MaterialRequestItem } from "features/MaterialRequests/types/material-request.types";
import { materialRequestLineRemaining } from "features/MaterialRequests/utils/material-request.utils";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import type { QuotationItemFormRow } from "features/Quotations/utils/quotationItem.utils";

/**
 * Maps MR lines to PO BOQ form rows using **remaining** requested quantity
 * (requested − net issued), skipping lines without a product or with nothing left to order.
 */
export function materialRequestItemsToPurchaseOrderBoqRows(
  items: MaterialRequestItem[] | null | undefined,
): QuotationItemFormRow[] {
  if (!items?.length) return [];
  const out: QuotationItemFormRow[] = [];
  for (const it of items) {
    const pid = Number(it.productId ?? it.porductId ?? it.product?.id);
    // if (!Number.isFinite(pid) || pid <= 0) continue;
    const qty = materialRequestLineRemaining(it);
    if (qty <= 0) continue;
    const unit =
      String(
        it.unit ?? it.product?.uom?.code ?? it.product?.uom?.name ?? "PCS",
      ).trim() || "PCS";
    const rateRaw =
      it.rate ?? it.product?.standardRate ?? it.product?.purchaseCost;
    const rate = Number(rateRaw);
    const safeRate = Number.isFinite(rate) && rate >= 0 ? rate : 0;
    const description =
      String(it.description ?? "").trim() ||
      String(it.remarks ?? "").trim() ||
      String(it.product?.name ?? "").trim() ||
      "Material";
    out.push({
      type: QuotationItemType.MATERIAL,
      description,
      productId: pid,
      quantity: qty,
      unit,
      rate: safeRate,
      materialRequestItemId: it.id ?? null,
    });
  }
  return out;
}
